import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Avatar, {HasAvatar} from 'ui-library/avatar/Avatar';
import {AvatarSize, AvatarShape} from 'ui-library/avatar/AvatarConstants';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

export default function VersionHistoryItemAvatar({
  user,
  tooltipText,
}: {
  user: HasAvatar;
  tooltipText?: string | JSX.Element;
}): JSX.Element {
  return (
    <div className={css(styles.flexRow)}>
      <Avatar size={AvatarSize.XXSMALL} shape={AvatarShape.CIRCLE} entity={user} showTooltip={false} />
      <Tooltip placement={FloatingPlacement.TOP} text={tooltipText}>
        <span className={css(styles.userText)}>{user.name}</span>
      </Tooltip>
    </div>
  );
}

const styles = StyleSheet.create({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: '5px',
  },
  userText: {
    fontSize: '12px',
    lineHeight: '16px',
  },
});
